import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_COURSE_FAQ,
  GET_COURSE_FAQS,
  GET_COURSE_FAQS_BY_FILTER,
  GET_COURSE_FAQS_BY_FILTER_CURRENT_TEACHER,
  ADD_COURSE_FAQ,
  UPDATE_COURSE_FAQ,
  DELETE_COURSE_FAQ,
} from '../../../../../queries/modules/class-room/course-faq';

export async function getCourseFaqs(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSE_FAQS,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setCourseFaqs', data.getCourseFaqs);
      context.commit('setSuccess', null);
      return data.getCourseFAQs
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getCourseFaq(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSE_FAQ,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setSuccess', null);
      return data.getCourseFAQ
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getCourseFaqsByFilter(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSE_FAQS_BY_FILTER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setCourseFaqs', data.getCourseFAQsByFilter);
      context.commit('setSuccess', null);
      return data.getCourseFAQsByFilter
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function getCourseFaqsByFilterCurrentTeacher(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSE_FAQS_BY_FILTER_CURRENT_TEACHER,
        variables: payload,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setCourseFaqs', data.getCourseFAQsByFilterCurrentTeacher);
      context.commit('setSuccess', null);
      return data.getCourseFAQsByFilterCurrentTeacher
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addCourseFaq(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_COURSE_FAQ,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;


    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const courseFaqs = [...context.state.courseFaqs];
      courseFaqs.unshift(data.addCourseFAQ);
      context.commit('setCourseFaqs', courseFaqs);
      context.commit('setSuccess', newItemSuccess(data.addCourseFAQ.question));

      return data.addCourseFAQ
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateCourseFaq(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_COURSE_FAQ,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.courseFaqs.findIndex(item => item.id === data.updateCourseFAQ.id);
      const courseFaqs = [
        ...context.state.courseFaqs.slice(0, index),
        data.updateCourseFAQ,
        ...context.state.courseFaqs.slice(index + 1)
      ];
      context.commit('setCourseFaqs', courseFaqs);
      context.commit('setSuccess', updateItemSuccess(data.updateCourseFAQ.question));

      return data.updateCourseFAQ
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteCourseFaq(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_COURSE_FAQ,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.courseFaqs.findIndex(item => item.id === data.deleteCourseFAQ.id);
      const courseFaqs = [
        ...context.state.courseFaqs.slice(0, index),
        ...context.state.courseFaqs.slice(index + 1)
      ];
      context.commit('setCourseFaqs', courseFaqs);
      context.commit('setSuccess', deleteItemSuccess(data.deleteCourseFAQ.question));

      return data.deleteCourseFAQ
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

